import React, { useRef, useState, useEffect } from "react";
import emailjs from "emailjs-com";
import "./FormStyles.css";

const Form = () => {
  const form = useRef();
  const [submitted, setSubmitted] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      "service_s3a2j1p", // service ID
      "template_6mddteg", // template ID
      form.current,
      "OH0h2jMvu6q4cUOuC" // public key
    ).then(
      (result) => {
        console.log(result.text);
        setSubmitted(true);
      },
      (error) => {
        console.log(error.text);
        alert("Oops! Something went wrong.");
      }
    );

    e.target.reset();
  };

  useEffect(() => {
    if (submitted) {
      const timer = setTimeout(() => setSubmitted(false), 5000);
      return () => clearTimeout(timer);
    }
  }, [submitted]);

  return (
    <div className="form">
      {submitted && (
        <div className="modal-overlay">
          <div className="modal">
            <p>Thanks for reaching out! I’ll get back to you as soon as possible ^^</p>
            <button className="close-btn" onClick={() => setSubmitted(false)}>
              Close
            </button>
          </div>
        </div>
      )}
      <form ref={form} onSubmit={sendEmail}>
        <label>Your Name</label>
        <input type="text" name="name" required />

        <label>Email</label>
        <input type="email" name="email" required />

        <label>Subject</label>
        <input type="text" name="title" required />

        <label>Message</label>
        <textarea name="message" rows="6" placeholder="Type your message here!" required />

        <button className="btn" type="submit">SUBMIT</button>
      </form>
    </div>
  );
};

export default Form;
